export default __webpack_public_path__ + "static/media/img--LUX-living-1.66136ff0.jpg";